// Small display helpers for the Lists page (lifted from the retired List Builder).
import { FB_CODE_TO_API } from '../../lib/athleteSearch';

// Longest ILIKE substring first so "Defensive End" abbreviates to EDGE, not DL.
const ABBREV_ORDER = ['EDGE', 'WR', 'RB', 'QB', 'TE', 'LB', 'CB', 'OL', 'DL', 'ATH', 'K', 'P', 'S'];

export const initials = (name) => (name || '').split(/\s+/).filter(Boolean).map((w) => w[0]).join('').slice(0, 2).toUpperCase();

// Round to whole inches first: float modulo on values like 73.3 otherwise renders "6'1.2999999999999972"".
export const fmtHt = (inches) => {
  if (!inches) return null;
  const total = Math.round(inches);
  return `${Math.floor(total / 12)}'${total % 12}"`;
};

export const posAbbrev = (name) => {
  if (!name) return '—';
  const lower = name.toLowerCase();
  for (const code of ABBREV_ORDER) {
    const api = FB_CODE_TO_API[code];
    if (api && lower.includes(api.toLowerCase())) return code;
  }
  return name.slice(0, 3).toUpperCase();
};

export const fmtHtWt = (p) => {
  const ht = fmtHt(p.height_inches);
  const wt = p.weight_lbs ? Math.round(p.weight_lbs) : null;
  if (ht && wt) return `${ht} · ${wt}`;
  return ht || (wt ? String(wt) : '—');
};

export const classOf = (p) => (p.graduation_year ? `'${String(p.graduation_year).slice(-2)}` : '—');
